import { render, staticRenderFns } from "./UserSocialNetworkComponent.vue?vue&type=template&id=1ec812da"
import script from "./UserSocialNetworkComponent.vue?vue&type=script&lang=js"
export * from "./UserSocialNetworkComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports